import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { VatItem } from 'src/app/api/models';
import { VatService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-input-categories',
  templateUrl: './modal-input-categories.component.html',
  styleUrls: ['./modal-input-categories.component.scss'],
})
export class ModalInputCategoriesComponent {
  button_ok_title: string;
  question_title: string;
  value = new FormControl('', Validators.required);
  iva: VatItem[] = [];
  selectedIva = new FormControl(undefined, Validators.required);

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    public vatService: VatService
  ) {
    this.getIva();
    this.button_ok_title = config.data!.button_ok_title;
    this.question_title = config.data!.question_title;
    if (config.data!.initial_value) {
      this.value.setValue(config.data!.initial_value.name);
      this.selectedIva.setValue(config.data!.initial_value.vat_id);
    }
  }

  getIva() {
    this.vatService.vatControllerGetAll().subscribe({
      next: res => {
        this.iva = res.data.list;
      },
    });
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({ value: { name: this.value.value, vat_id: this.selectedIva.value } });
  }
}
